
export const environment = {
  production: false,
  rememberMeKey: '2_kfs_32sad_s',
  storageKey: '_01_A_zKo',
  timerVerification: 'verificationTimerValue',
  base_url: 'https://dev-api.esqyre.com/onboarding/api/v1/',
  image_url: 'https://dev-api.esqyre.com/common/api/v1/Upload/uploadFile',
  common_url: 'https://dev-api.esqyre.com/common/api/v1/Content/',
  googleKey: 'AIzaSyAbsZUg1cv51-w4ejJh93F4w5DODotUWlk',
  operational_url: 'https://dev-api.esqyre.com/operational/api/v1/',
  socket_url: 'https://dev-socket.esqyre.com',
  firebaseConfig: {
    apiKey: 'AIzaSyBFDv0rLCEm6M3GpGFz-YC21Il17kRJ1Ts',
    authDomain: 'esqyre-cars.firebaseapp.com',
    projectId: 'esqyre-cars',
    storageBucket: 'esqyre-cars.appspot.com',
    messagingSenderId: '81689601348',
    appId: '1:81689601348:web:d6ba45e0a7264d58496311',
    measurementId: 'G-N8EDK7CLV9',
    vapidKey: 'BC1kZENinr1eTHAWcGJFYsBasPg8b4LTOW9NPynltJF2YT6ZI500NpjYlBTKkuvBzatQI_NF-tZnwD4f1wqoWJ0'
  },
  STRIPE_SECRET_KEY: 'sk_test_51PzXjhP0zHXo5NEz23hvKES40yyJ4YTkxqQHylXqTBr4tXtQcyjqzv9yyWxitH4iwAyyGwXmxWOhLkXhZOBPi0kT00PAZJAdbS',
  STRIPE_PUBLISH_KEY: 'pk_test_51RLouMP3KxPa52E5VDAfVL0cp5pjLVGaBgWDZzmDzOzBrDDR127MNM8wlh905WR11RfDLCCUKFj4wAzA9an9tWun00FzHTkd77',
  payment_url: 'https://dev-api.esqyre.com/operational/api/v1/',
  path: '/firebase-messaging-sw.js',
  scope: '/'
};
